import React, { useEffect, useState } from 'react';

import { SafeAreaView } from 'react-native';
import { ScrollView } from 'react-native';

import SubStatsDailycounts from './SubStatsDailycounts.js';
import SubStatsHourlycounts from './SubStatsHourlycounts.js';
import SubStatsMinutescounts from './SubStatsMinutescounts.js';
import { Text, View } from '../components/Themed';
import { log, logerror } from './Common';
import styles from '../assets/styles/styles';


export default function TabStatVertScreenLim() {
  const [stateUpdate, setStateUpdate] = useState(0);


  useEffect(() => {
    const interval = setInterval(() => {
      log('handleDatay xxx ');
      setStateUpdate(stateUpdate + 1);
    }, 5000);
    return () => clearInterval(interval);
  }, [])


  return (
    <SafeAreaView style={styles.container_main}>
      <ScrollView style={styles.container_main}>
        <View style={styles.tableCol}>


          <View style={styles.tableCol}>
            <SubStatsMinutescounts
              title="Last hour"
              type="2"
              limmins="60"
              w="340"
              h="240"
              stateUpdate={stateUpdate}
            />
          </View>
          <View style={styles.tableCol}>
            <SubStatsHourlycounts
              title="Last 48 hours"
              type="2"
              limhour="48"
              w="340"
              h="240"
            />
          </View>
          <View style={styles.tableCol}>
            <SubStatsHourlycounts
              title="Last 20 Day"
              type="2"
              limhour="480"
              w="340"
              h="240"
            />
          </View>
          <View style={styles.tableCol}>
            <SubStatsDailycounts
              title="All Counts"
              type="2"
              w="340"
              h="240"
            />
          </View>


        </View>
      </ScrollView>

    </SafeAreaView >
  );
}
